/**
 *
 */
export function useTabSelection(): {
  selectTab: (
    tabs: HTMLElement[],
    panels: HTMLElement[],
    index: number,
    onIndexChange: (index: number) => void,
  ) => void;
  handleTabSelect: (event: CustomEvent, onSelect: (index: number) => void) => void;
} {
  function selectTab(
    tabs: HTMLElement[],
    panels: HTMLElement[],
    index: number,
    onIndexChange: (index: number) => void,
  ): void {
    if (index < 0 || index >= tabs.length) return;
    if (tabs[index]?.hasAttribute("disabled")) return;

    onIndexChange(index);

    /*                                                                            */
    tabs.forEach((tab, i) => {
      const isSelected = i === index;
      const interactiveElement = tab.querySelector("button, a");
      if (interactiveElement) {
        interactiveElement.setAttribute("aria-selected", String(isSelected));
        interactiveElement.setAttribute("tabindex", isSelected ? "0" : "-1");
      }
    });

    /*                                                 */
    if (panels.length > 0) {
      panels.forEach((panel, i) => {
        const isVisible = i === index;
        panel.setAttribute("aria-hidden", String(!isVisible));
      });
    }
  }

  function handleTabSelect(event: CustomEvent, onSelect: (index: number) => void): void {
    const index = parseInt(event.detail.index, 10);
    if (!isNaN(index)) {
      onSelect(index);
    }
  }

  return {
    selectTab,
    handleTabSelect,
  };
}
